import { isStoreAliasFirst, useStoreNameConfig } from 'hooks/business/store/useStoreName';
import { useGetRegionLabel } from 'hooks/business/useRegion';
import { ItemV5 } from '../types';

export const useStoreInfo = (item: ItemV5) => {
  const { platform, region, shopName, shopAlias } = item;
  const { config } = useStoreNameConfig();
  const aliasFirst = isStoreAliasFirst(config, platform, region);
  const getRegionLabel = useGetRegionLabel();

  return `${platform}-${getRegionLabel(region?.toLowerCase() as General.Region)}-${
    aliasFirst ? shopAlias || shopName : shopName
  }`;
};
